import { CommandParameterTemplate } from "../commandParameterTemplate/commandParameterTemplate";
import { FlowTemplate } from "../flowTemplate/flowTemplate";

/**
 * CommandTemplate - defines a command, that comes from
 * the server, should be rendered in the UI and can be executed
 * by the user
 */
export class CommandTemplate{

  /**
   * name - name of the command
   */
  name: string | undefined;

  /**
   * settings - settings of the command, object
   */
  settings: any | undefined;

  /**
   * parameters - parameters of the command
   */
  parameters: CommandParameterTemplate[] | undefined;

  /**
   * flow - flow of the command, that should be used
   */
  flow: FlowTemplate | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.settings = payload.settings;
      if(payload.parameters){
        this.parameters = new Array<CommandParameterTemplate>();
        payload.parameters.map( (parameter: any) => {
          this.parameters.push(new CommandParameterTemplate(parameter));
        })
      }
      if(payload.flow){
        this.flow = new FlowTemplate(payload.flow);
      }
    }
  }
}

/**
 * CommandInput - will be sent to the server
 */
export class CommandInput {

  /**
   * name - name of the command
   */
  name: string;

  /**
   * parameters - parameters of the command
   */
  parameters: any | undefined;

  addParameter(name: string, value: any){
    if(!this.parameters){
      this.parameters = {};
    }
    this.parameters[name] = value;
  }
}

